const useStyles = {
  footer: {
    height: 'auto',
  },
  heading: {
    fontWeight: '300',
    width: '100%',
    textAlign: 'center',
    marginTop: 3,
    marginBottom: 3,
  },
  slideOuterContainer: {
    gap: 3,
  },
  slideInnerContainer: {
    flexDirection: 'column',
    alignItems: 'center',
    gap: '4px',
  },
  slideSubtitle: {
    lineHeight: '1.4',
    letterSpacing: '0',
  },
}

export default useStyles
